enum PermissionGroup {
  App = 'App',
  AppMonitoring = 'AppMonitoring',
  Dashboard = 'Dashboard',
  Integrations = 'Integrations',
  History = 'History',
  User = 'User',
  OrganisationUnit = 'OrganisationUnit',
  ResidentsSettings = 'ResidentsSettings',
  Scenario = 'Scenario',
  TemporaryAccess = 'TemporaryAccess',
  Settings = 'Settings',
  Alerts = 'Alerts',
  CentralSupportPortal = 'CentralSupportPortal',
  CentralSupportMonitoring = 'CentralSupportMonitoring',
  InsightsPortal = 'InsightsPortal',
}

export default PermissionGroup;
